import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { Plus, Trash2, Edit } from "lucide-react";

export default function TestimonialListPage() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTestimonials = async () => {
    try {
      const res = await api.get("/testimonial");
      setTestimonials(res.data || []);
    } catch {
      toast.error("Yorumlar yüklenemedi");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const handleDelete = (id) => {
    if (!window.confirm("Bu yorumu silmek istediğinize emin misiniz?")) return;
    api
      .delete(`/testimonial/${id}`)
      .then(() => {
        toast.success("Yorum silindi");
        fetchTestimonials();
      })
      .catch(() => toast.error("Silme başarısız"));
  };

  if (loading)
    return (
      <div className="page-loading">
        <div className="loading-spinner" />
        <p>Yükleniyor...</p>
      </div>
    );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Müşteri Yorumları</h2>
          <p className="page-subtitle">{testimonials.length} yorum</p>
        </div>
        <Link to="/add-testimonial" className="btn btn-primary">
          <Plus size={18} /> Yeni Yorum
        </Link>
      </div>

      <div className="content-card no-padding">
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th>Ad Soyad</th>
                <th>Pozisyon</th>
                <th>Yorum</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {testimonials.map((t) => (
                <tr key={t.testimonialId}>
                  <td className="fw-medium">{t.clientFullName}</td>
                  <td>{t.clientPosition}</td>
                  <td>
                    {t.clientComment && t.clientComment.length > 100
                      ? t.clientComment.substring(0, 100) + "..."
                      : t.clientComment}
                  </td>
                  <td>
                    <div className="action-buttons">
                      <Link
                        to={`/edit-testimonial/${t.testimonialId}`}
                        className="btn-icon edit"
                        title="Düzenle"
                      >
                        <Edit size={16} />
                      </Link>
                      <button
                        onClick={() => handleDelete(t.testimonialId)}
                        className="btn-icon delete"
                        title="Sil"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {testimonials.length === 0 && (
        <div className="empty-state">
          <p>Henüz yorum eklenmemiş</p>
          <Link to="/add-testimonial" className="btn btn-primary">
            <Plus size={18} /> İlk Yorumu Ekle
          </Link>
        </div>
      )}
    </div>
  );
}
